import React from "react";
import Banner from "../../components/Banner/Banner";
import BannerBottom from "../../components/Banner/BannerBottom";
import YearProduct from "../../components/home/YearProduct/YearProduct";
import Earring from "../../components/home/category/Earring";
import Ring from "../../components/home/category/Ring";
import Chain from "../../components/home/category/Chain";
import Dollar from "../../components/home/category/Dollar";
import Sliver from "../../components/home/category/Sliver";
import BombayNeckles from "../../components/home/category/BombayNeckles";
import Stud from "../../components/home/category/Stud";

const Home = () => {
  
  return (
    <div className="w-full mx-auto">
      <Banner />
      <BannerBottom />
      <div className="max-w-container mx-auto px-4">
        {/* <Sale /> */}
        {/* <NewArrivals /> */}
        {/* <Necklace/> */}
        <BombayNeckles/>
        <Stud/>
        <Earring/>
        <Ring/>
        <Chain/>
        <Dollar/>
        
        {/* <BestSellers /> */}
        <YearProduct />
        {/* <SpecialOffers /> */}
        <Sliver />
      </div>
    </div>
  );
};

export default Home;
